import axios from 'axios'
import configAws from '../config/aws'
import config from '../config'
import { navigation } from '../utils/Utils'
import { Amplify, Auth } from 'aws-amplify'

const axiosApiInstance = axios.create({
  baseURL: config.API_BASE_URL,
})

Amplify.configure({
  Auth: {
    ...configAws.aws,
    authenticationFlowType: 'CUSTOM_AUTH',
  },
})

axiosApiInstance.interceptors.request.use(
  async (cfg) => {
    try {
      let newIdToken
      const refreshSession = await fetch(configAws.aws.refreshSessionUrl, {
        headers: {
          'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
          'Content-Type': 'application/x-amz-json-1.1',
        },
        mode: 'cors',
        cache: 'no-cache',
        method: 'POST',
        body: JSON.stringify({
          ClientId: configAws.aws.userPoolWebClientId,
          AuthFlow: 'REFRESH_TOKEN_AUTH',
          AuthParameters: {
            REFRESH_TOKEN: localStorage.getItem('refresh_token'),
          },
        }),
      })

      if (refreshSession.status !== 200) {
        await Auth.signOut({ global: false })
        navigation.navigate('/')
      }

      const response = await refreshSession.json()
      const userTokenResponse = response?.AuthenticationResult?.IdToken

      newIdToken = userTokenResponse
      if (newIdToken) {
        localStorage.setItem('access_token', newIdToken)
        return requestWithAuthorization(cfg, newIdToken)
      }
    } catch (e) {
      console.log(e)
      navigation.navigate('/')
    }
    return cfg
  },
  (error) => Promise.reject(error)
)

const post = async (path, data = {}, headers = {}, withToken = true) => {
  const res = await axiosApiInstance({
    method: 'post',
    url: path,
    data,
    headers: {
      Authorization: withToken
        ? `bearer ${localStorage.getItem('access_token')}`
        : '',
      ...headers,
    },
  })
  return res.data
}

const put = async (path, data = {}, headers = {}) => {
  const res = await axiosApiInstance({
    method: 'put',
    url: path,
    data,
    headers: {
      Authorization: `bearer ${localStorage.getItem('access_token')}`,
      ...headers,
    },
  })
  return res.data
}

const get = async (
  path,
  params = {},
  headers = {},
  config = {},
  withToken = true
) => {
  const res = await axiosApiInstance(
    {
      method: 'get',
      url: path,
      params,
      headers: {
        Authorization: withToken
          ? `bearer ${localStorage.getItem('access_token')}`
          : '',
        ...headers,
      },
    },
    config
  )
  return res.data
}

const apiDelete = async (path, params = {}, headers = {}) => {
  const res = await axiosApiInstance({
    method: 'delete',
    url: path,
    params,
    headers: {
      Authorization: `bearer ${localStorage.getItem('access_token')}`,
      ...headers,
    },
    validateStatus: function (status) {
      return (status >= 200 && status < 300) || status === 400
    },
  })
  return res.data
}

/*const getWithHeader = async (path, refreshToken) => {
  const conf = {
    method: 'get',
    url: path,
    headers: {
      Authorization: `bearer ${refreshToken}`,
      Accept: 'application/json',
    },
  }
  const res = await api(conf)
  return res.data
}*/

const submitCredentials = async (login, password) => {
  const response = await post('/token', { login, password })
  return response
}

const requestWithAuthorization = (request, token) => ({
  ...request,
  headers: {
    ...request.headers,
    Authorization: `bearer ${token}`,
  },
})

const getInvoicesFile = async (item) => {
  const res = await axiosApiInstance({
    method: 'GET',
    url: `${config.API_BASE_URL}/me/invoices/${item.id}`,
    headers: {
      Authorization: `bearer ${localStorage.getItem('access_token')}`,
    },
    validateStatus: (status) =>
      status === 302 || status === 400 || status === 200,
  })

  axios
    .get(res?.request?.responseURL, {
      responseType: 'blob',
    })
    .then((response) => {
      const href = URL.createObjectURL(response.data)

      const link = document.createElement('a')
      link.href = href
      link.target = '_blank'
      const name = 'Facture'
        .split(';')[0]
        .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '')
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    })
}

const subscripeNewsletter = async (email) => {
  const response = await post('/subscribe_newsletter', { email }, {}, false)
  return response
}

const fetchPaymentIntent = async (orderId) => {
  const response = await post(`/orders/${orderId}/payments`)
  return response
}

export default {
  get,
  post,
  put,
  apiDelete,
  submitCredentials,
  getInvoicesFile,
  subscripeNewsletter,
  fetchPaymentIntent,
}
